import React from "react";
import * as S from "./Points.styles";
import { Points as PointsType } from "../../UniFiPartnerHub.types";

export const Points = ({ points }: { points: PointsType }) => {
  return (
    <S.PointsContainer>
      {points.map((point, index) => (
        <S.Point key={`${point.copy}-${index}`}>
          <S.StyleableSvgImage src={point.icon} width={48} height={48} />
          <S.CopyContainer>
            <S.Title>{point.copy.title}</S.Title>
            <S.Description
              dangerouslySetInnerHTML={{ __html: point.copy.description }}
            />
          </S.CopyContainer>
        </S.Point>
      ))}
    </S.PointsContainer>
  );
};
